import React from 'react';
import { observer } from 'mobx-react';
import { ProductListTemplate } from 'themes/application/product/pages';
import { setCurrentView } from 'core/utils';
import { ProductViewStore } from 'application/product/stores';

@setCurrentView((rootStore) => new ProductViewStore(rootStore), 'listViewStore')
@observer
class ProductList extends React.Component {
    render() {
        return <ProductListTemplate {...this.props} />
    }
}

export default ProductList;